import { render, staticRenderFns } from "./KissPayDepositPanel.vue?vue&type=template&id=4df79ce8&scoped=true&"
import script from "./KissPayDepositPanel.vue?vue&type=script&lang=js&"
export * from "./KissPayDepositPanel.vue?vue&type=script&lang=js&"
import style0 from "./KissPayDepositPanel.vue?vue&type=style&index=0&id=4df79ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df79ce8",
  null
  
)

export default component.exports